import "../initializers/turbo_preload_headers"
import "../initializers/turbo_render"
import "../initializers/turbo_events"
import "../initializers/turbo_frames"
import "../initializers/turbo_form"
import "../initializers/turbo_native"
import "../initializers/turbo_preview_refresh"
import "../initializers/container_queries_polyfill"
import "../initializers/mobile_safari_active_pseudo_support"
import "../initializers/airbrake"
import "../initializers/current"
import "../initializers/native_analytics"

import { Application } from "@hotwired/stimulus"
import { registerControllers } from 'stimulus-vite-helpers'

const application = Application.start()
const controllers = import.meta.glob('../controllers/**/*_controller.js', { eager: true })

registerControllers(application, controllers)

